<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zmeNer/cover.jpeg?1684514467348" alt="This image is the cover for the book Emperor Zhu Tian, Book 22"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Emperor Zhu Tian, Book 22
      </h1>
      <p class="bookDescription body article font2">
        <p class="ql-long-26956671" line="OCMj"><strong>He was betrayed, besides his pain, he strengthened his determination to make himself strong, because only in this way can those who betrayed him be punished.</strong></p><p class="ql-long-26956671" line="2wG3">Qi Tianyu has lost his life unexpectedly due to the calculation of a good brother.  They have known each other for many years, and Qi Tianyu never imagined that the brother who experienced all the dangerous time together would betray him for the sake of small profits! At the last minute, Qi Tianyu exploded his body, trying to die with him, but didn't succeed. </p><p class="ql-long-26956671" line="Kh3A">Qi Tianyu contained hate to die. In a moment, he was born again! His soul is attached to the body of a strange man. This man, like him, was hurt by others. Feeling the tragic experience of this man, Qi Tianyu decided to practice martial arts and help this man to get revenge. At the same time, he had to make the person who betrayed him to pay the price!</p><p class="ql-long-26956671" line="4XJC">With the memory of previous life, he has a superb understanding of martial arts, high speed of the practice, and soon became a leader among the crowd. He eventually became the Emperor of Heaven, and his wishes were realized one by one.</p><p></p><p><strong>☆About the Author☆</strong></p><p class="ql-long-26956671" line="tsk1">Tian Mu, an excellent online novelist. His novels have rich and tortuous plots, and his novels have distinctive personality, which is loved by many readers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tian Mu, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7a7cbe85